























import {
    defineComponent,
    PropType,
} from '@vue/composition-api';
import {
    SdsTabItem,
    SdsTabList,
    SdsTabs as SdsTabsLib,
} from '@superbet-group/web.lib.ui-components';

import { TabItem } from './types';

export default defineComponent({
    name: 'SdsTabs',
    props: {
        // The controlled value of the tab to activate. Should be bound with `v-model`, but this will only work in Vue 3.
        modelValue: {
            type: String,
            required: false,
            default: '',
        },
        items: {
            type: Array as PropType<TabItem[]>,
            required: false,
            default: () => [],
        },
        hasUnderline: {
            type: Boolean,
            default: true,
        },
        background: {
            type: String as PropType<'default' | 'dark-color' | 'bright-color'>,
            required: false,
            default: undefined,
        },
    },
    emits: [
        'update:modelValue',
        'change',
    ],
    setup(props, { emit }) {
        function updateSelectedTab(value: string, triggerActions = true) {
            if (value === props.modelValue) {
                return;
            }

            emit('update:modelValue', value);
            emit('change', value);

            const item = props.items.find((i) => i.value === value);

            if (item?.disabled) {
                return;
            }

            if (!triggerActions) {
                return;
            }

            item?.onClick?.();
        }

        return {
            updateSelectedTab,
        };
    },
    components: {
        SdsTabItem,
        SdsTabList,
        SdsTabsLib,
    },
});
